var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbFnf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2552",
    "data-name": "\\uC0AC\\uAC01\\uD615 2552",
    width: 24,
    height: 12,
    transform: "translate(-12395 2367)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2551",
    "data-name": "\\uC0AC\\uAC01\\uD615 2551",
    width: 24.048,
    height: 11.099,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4115",
    "data-name": "\\uADF8\\uB8F9 4115",
    transform: "translate(-864 -727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2978",
    "data-name": "\\uD328\\uC2A4 2978",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(864 727)",
    fill: "#e7e9ef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_9",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 9",
    transform: "translate(13267 -1626)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4114",
    "data-name": "\\uADF8\\uB8F9 4114",
    transform: "translate(-12395 2367.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4113",
    "data-name": "\\uADF8\\uB8F9 4113",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2979",
    "data-name": "\\uD328\\uC2A4 2979",
    d: "M120.955,10.427l-2.534-2.514a11.908,11.908,0,0,0,.546-1.458h1.54a.065.065,0,0,0,.065-.065V5.053a.065.065,0,0,0-.065-.065H117.9a.065.065,0,0,0-.063.049A14.267,14.267,0,0,1,117.3,6.8l-1.744-1.73a4.967,4.967,0,0,0,1.075-.824,2.552,2.552,0,0,0-.7-3.906,2.6,2.6,0,0,0-3.116.41L112.8.771a2.575,2.575,0,0,0-.7,1.267,2.614,2.614,0,0,0,.55,2.186c.177.2.351.379.534.554a9.341,9.341,0,0,0-.926.655,3.2,3.2,0,0,0,2.038,5.665,4.092,4.092,0,0,0,3.375-1.869l1.245,1.235a.209.209,0,0,0,.148.061h1.855a.057.057,0,0,0,.04-.1m-5.19-8.071a1.164,1.164,0,0,1-.248.939,3.626,3.626,0,0,1-.893.616l-.15.085c-.39-.375-.67-.683-.672-.685a1.152,1.152,0,0,1-.248-.938,1.158,1.158,0,0,1,.686-.821,1.073,1.073,0,0,1,.964.061,1.133,1.133,0,0,1,.562.744m-1.474,7.276a1.743,1.743,0,0,1-1.361-.624,1.764,1.764,0,0,1,.275-2.459,6.486,6.486,0,0,1,1.053-.7l2.348,2.33a2.776,2.776,0,0,1-2.316,1.454",
    transform: "translate(-104.317 0)",
    fill: "#00263e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2980",
    "data-name": "\\uD328\\uC2A4 2980",
    d: "M6.162,4.47H.046A.046.046,0,0,0,0,4.516V14.677a.046.046,0,0,0,.046.046H1.42a.046.046,0,0,0,.046-.046V10.652h4.08a.046.046,0,0,0,.046-.046V9.233h0a.046.046,0,0,0-.046-.046H1.466V5.936h4.7a.046.046,0,0,0,.046-.046V4.516a.046.046,0,0,0-.046-.046",
    transform: "translate(0 -4.198)",
    fill: "#00263e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2981",
    "data-name": "\\uD328\\uC2A4 2981",
    d: "M299,4.47H292.88a.046.046,0,0,0-.046.046V14.677a.046.046,0,0,0,.046.046h1.374a.046.046,0,0,0,.046-.046V10.652h4.08a.046.046,0,0,0,.046-.046V9.233h0a.046.046,0,0,0-.046-.046H294.3V5.936H299a.046.046,0,0,0,.046-.046V4.516A.046.046,0,0,0,299,4.47",
    transform: "translate(-274.994 -4.198)",
    fill: "#00263e"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbFnf);
export default __webpack_public_path__ + "static/media/thumbFnf.1deb5bfe5bfef83774f27da484eb814d.svg";
export { ForwardRef as ReactComponent };